document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.swatch-name-container').forEach(container => {
    const nameEl   = container.querySelector('.js-swatch-name');
    const swatches = container.nextElementSibling;
    if (!nameEl || !swatches) return;

    // collect both the radios and the label circles
    const inputs = Array.from(swatches.querySelectorAll('.js-swatch-input'));
    const labels = Array.from(swatches.querySelectorAll('.color-swatch'));
    if (!inputs.length || !labels.length) return;

    function setToChecked() {
      const sel = swatches.querySelector('.js-swatch-input:checked');
      if (sel) nameEl.textContent = sel.dataset.value;
    }

    // handle hover on inputs
    inputs.forEach(input => {
      input.addEventListener('mouseenter', () => {
        nameEl.textContent = input.dataset.value;
      });
      input.addEventListener('mouseleave', setToChecked);
    });

    // handle hover on label circles
    labels.forEach(label => {
      const val = label.dataset.value;
      label.addEventListener('mouseenter', () => {
        nameEl.textContent = val;
      });
      label.addEventListener('mouseleave', setToChecked);
    });

    // also update on change/click
    inputs.forEach(input => {
      input.addEventListener('change', setToChecked);
    });

    setToChecked();
  });
});
